import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saInterCuHandoutCellChartConfig } from '../cellChartConfigs';

interface InterCuHandoutSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuHandoutSaCell: React.FC<InterCuHandoutSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saInterCuHandoutCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default InterCuHandoutSaCell;
